import { Breakpoint, Color, FontWeight, Markdown, Typography } from '@elearning-platform/ui';
import { styled } from 'styled-components';

export const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 10px;
`;

export const ExerciseStep = styled.div`
  padding: 24px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  background-color: ${Color.White};
`;

export const ExerciseStepTitle = styled(Typography)`
  color: ${Color.Gray800};
`;

export const StyledMarkdown = styled(Markdown)`
  strong {
    font-weight: ${FontWeight.Regular};
  }
`;

export const RadioButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const StyledRadioButtons = styled(RadioButtons)`
  @media ${Breakpoint.Tablet} {
    flex-direction: row;
  }
`;

export const IconWrapper = styled.div`
  display: inline-flex;
  position: relative;
  top: 4px;
  left: 10px;
`;

export const BrandColorTypography = styled(Typography)`
  color: ${Color.Brand100};
  cursor: default;
`;

export const TextsWithTooltipWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const TextWithTooltip = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  @media ${Breakpoint.Tablet} {
    flex-direction: row;
    gap: 8px;
  }
`;

export const TooltipBase = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  width: fit-content;
`;
